module.exports = __webpack_public_path__ + "img/rabren.cf5159de.jpg";